import { useState } from "react";
import { styled } from "@mui/material/styles";
import {
  LinearProgress,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Grid,
} from "@mui/material";
import moment from "moment";

const ProgressGrid = styled(Grid)({
  background: "#FAFAFA",
  borderRadius: "10px",
  padding: "8px 16px",
  marginBottom: "16px",
  alignItems: "top",
});

const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  width: "200px",
  borderRadius: 10,
  marginTop: 3,
  marginBottom: 3,
  marginRight: theme.spacing(2),
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#161729",
  },
  "& .MuiLinearProgress-colorPrimary": {
    backgroundColor: "#D3D3D3",
  },
}));

type Props = {
  totalCheckin: number;
  completedCheckins: number;
  updateSelectedMonth: any;
  isFromCronJob?: boolean;
};

const ProgressSection = ({
  updateSelectedMonth,
  totalCheckin,
  completedCheckins,
  isFromCronJob,
}: Props) => {
  const [selectedMonth, setSelectedMonth] = useState(moment().format("MMMM"));

  const handleMonthChange = (event: any) => {
    setSelectedMonth(event.target.value);
    const selectedIndex =
      Number(moment().month(event.target.value).format("M")) - 1;
    updateSelectedMonth(selectedIndex);
  };

  return (
    <ProgressGrid container>
      <Grid xs={9}>
        <Grid container flexDirection="row">
          <Typography
            style={{ fontWeight: 700, fontSize: "14px", color: "#161728" }}
          >
            {"Total Checkin Progress in Past 30 Days:"}
          </Typography>
          <Typography
            variant="h6"
            style={{
              fontWeight: 400,
              fontSize: "14px",
              color: "#5C5D69",
              marginLeft: 3,
            }}
          >
            {selectedMonth}
          </Typography>
        </Grid>
        <ProgressBar
          variant="determinate"
          value={(completedCheckins / totalCheckin) * 100}
        />
        <Typography
          style={{
            fontWeight: 400,
            fontSize: "10px",
            color: "#5C5D68",
            marginLeft: 3,
          }}
        >{`${completedCheckins}/${totalCheckin} completed`}</Typography>
      </Grid>
      {!isFromCronJob && (
        <Grid xs={3}>
          <FormControl variant="standard" sx={{ width: "100%", height: 44 }}>
            <Select
              variant="filled"
              sx={{
                height: 44,
                borderRadius: "10px",
                border: "none",
                boxShadow: "none",
                fontSize: 18,
                fontWeight: "400",
                lineHeight: 0.75,
                "&:focus": {
                  boxShadow: "none",
                  background: "none",
                },
              }}
              value={selectedMonth}
              onChange={handleMonthChange}
              displayEmpty
              disableUnderline
              multiline={false}
            >
              <MenuItem value="January">January</MenuItem>
              <MenuItem value="February">February</MenuItem>
              <MenuItem value="March">March</MenuItem>
              <MenuItem value="April">April</MenuItem>
              <MenuItem value="May">May</MenuItem>
              <MenuItem value="June">June</MenuItem>
              <MenuItem value="July">July</MenuItem>
              <MenuItem value="August">August</MenuItem>
              <MenuItem value="September">September</MenuItem>
              <MenuItem value="October">October</MenuItem>
              <MenuItem value="November">November</MenuItem>
              <MenuItem value="December">December</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
    </ProgressGrid>
  );
};

export default ProgressSection;
